import React from 'react';
import './token-redemption-params.scss';
import {
  TokenRedemptionTypes,
  TokenRedemptionType,
} from 'constants/redemption';
import currencyFormat from 'utils/currencyFormat';

interface ITokenRedemptionParams {
  redemptionType: TokenRedemptionType;
  asset: any;
}

export default function TokenRedemptionParams({
  redemptionType,
  asset,
}: ITokenRedemptionParams) {
  return (
    <div className="token-redemption-params">
      <p className="p p_font-size_12 p_color_light-grey">Наменование токена</p>
      <p className="p p_color_blue mb_12">{asset.issuingInfo.tokenName}</p>
      <p className="p p_font-size_12 p_color_light-grey">
        Количество погашаемых токенов
      </p>
      <p className="p mb_12">{asset.actualCount}</p>
      <p className="p p_font-size_12 p_color_light-grey">Сумма требований</p>
      <p className="p mb_12">
        {currencyFormat(
          asset.actualCount * asset.issuingInfo.tokenPrice,
          true
        )}
      </p>
      <p className="p p_font-size_12 p_color_light-grey">Эмитент</p>
      <p className="p mb_12">{asset.issuer}</p>
      <p className="p p_font-size_12 p_color_light-grey">Обладатель токенов</p>
      <p className="p mb_12">{asset.owner}</p>
      <p className="p p_font-size_12 p_color_light-grey">Основание погашения</p>
      <p className="p">{TokenRedemptionTypes[redemptionType]}</p>
    </div>
  );
}
